import { Injectable } from "@angular/core";
import { OnBoardingApi } from "../../shared/nestjs/gd-only/services/on-boarding.api";
import { Subscription } from "rxjs";
import { NestResponsesProvider } from "../../shared/nestjs/nest-responses";
import { ResponseGetPercentOnBoardingNewCompany, RequestChecklistOnBoardingNewCompanyDto, ResponseChecklistOnBoardingNewCompanyDto } from "../../shared/nestjs/gd-only/dto/on-boarding.dto";
import { Platform } from "ionic-angular";

@Injectable()
export class CompanySetUpBloc {
  private subscriptions: Array<Subscription> = [];
  private _totalProgress = 0;
  private _dataPercentage: any;

  constructor(
    private onBoardingApi: OnBoardingApi,
    public nestResponse: NestResponsesProvider,
    private platform: Platform
  ) {

  }

  set totalProgress(data) {
    this._totalProgress = data;
  }

  get totalProgress() {
    return this._totalProgress;
  }

  set dataPercentage(data) {
    this._dataPercentage = data;
  }

  get dataPercentage() {
    return this._dataPercentage;
  }

  async doGetPercentOnBoardingNewCompany() {
    try {
      const objData = await this.getPercentOnBoardingNewCompany();
      this._totalProgress = objData.totalAllPercentage;
      this._dataPercentage = objData;
    } catch (error) { }
  }

  get completed() {
    let count = 0;
    for (let key in this._dataPercentage) {
      if (key === 'attendanceSetup') {
        if (this._dataPercentage[key].totalPercentage == 100) {
          count++;
        }
      } else if (key === 'claimSetup') {
        if (this._dataPercentage[key].totalPercentage == 100) {
          count++;
        }
      } else if (key === 'payrollSetup') {
        if (this._dataPercentage[key].totalPercentage == 100) {
          if (!this.platform.is('cordova')) count++;
        }
      } else if (key === 'requestApprovalSetup') {
        if (this._dataPercentage[key].totalPercentage == 100) {
          count++;
        }
      } else if (key === 'employeeSetup') {
        if (this._dataPercentage[key].totalPercentage == 100) {
          count++;
        }
      }
    }

    return count;
  }


  dispose() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getPercentOnBoardingNewCompany() {
    return new Promise<ResponseGetPercentOnBoardingNewCompany>((resolve, reject) => {
      this.subscriptions.push(
        this.onBoardingApi.getPercentOnBoardingNewCompany()
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      );
    });
  }

  checklistOnBoardingNewCompany(payload?: RequestChecklistOnBoardingNewCompanyDto) {
    return new Promise<ResponseChecklistOnBoardingNewCompanyDto>((resolve, reject) => {
      this.subscriptions.push(
        this.onBoardingApi.checklistOnBoardingNewCompany(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      );
    });
  }

}


// WEBPACK FOOTER //
// ./src/bloc/company/company-setup.bloc.ts